import { prefixObjectValues } from '../../utils';
const page = {
  cancelBtn: 'cancelBtn',
  updateBtn: 'updateBtn',
  submitBtn: 'submitBtn',
};

export default prefixObjectValues(page, 'profile-contact-info-page');
